import ExtranetProfileMenu from './ExtranetProfileMenu.container';

export default ExtranetProfileMenu;
